var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cart-popup__dialog" },
    [
      _c("TripleEyeHeader"),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "cart-popup__item-link" }, [
        _c(
          "button",
          {
            staticClass: "bt-akl-blue bt-eyecare-pop-orange",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("clickStart")
              }
            }
          },
          [_vm._v("자가진단 시작!")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cart-popup__content height-auto" }, [
      _c("div", { staticClass: "content_eyecare bgEvent" }, [
        _c("p", { staticClass: "eyecare_tit txtC" }, [
          _vm._v("\n        몸이 천냥이면 눈은 구백냥!"),
          _c("br"),
          _vm._v("\n        트리플 아이케어 프로그램과 함께하는"),
          _c("br"),
          _vm._v(" "),
          _c(
            "strong",
            {
              staticClass: "color_orange",
              staticStyle: { "font-size": "28px" }
            },
            [_vm._v("“눈 건강 자가진단 이벤트”")]
          ),
          _c("br"),
          _vm._v("\n        간편하게 자가진단 하시고 경품에도 응모해보세요."),
          _c("br"),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                color: "#aaa",
                "font-size": "12px",
                "text-align": "center",
                "line-height": "1",
                display: "inline-block"
              }
            },
            [_vm._v("* 이벤트 응모는 1인당 한번씩만 가능합니다.")]
          ),
          _vm._v(" "),
          _c("br"),
          _c("br")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "txtC" }, [
          _c("img", {
            staticStyle: { width: "100%", "max-width": "280px" },
            attrs: {
              src:
                "https://www.amway.co.kr/_ui/responsive/theme-blue/images/eyecare/00_intro_vis.png",
              alt: "Eye Care Event"
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "p",
          {
            staticStyle: {
              color: "#aaa",
              "font-size": "9px",
              "text-align": "right"
            }
          },
          [_vm._v("CN001953")]
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6786c446", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6786c446","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/triple-eye-care/component/intro.vue
// module id = null
// module chunks = 